export default [
  { text: "Дата", value: "transactionDateTime", type: "date", width: "12%" },
  { text: "Сумма", type: "text", value: "amountInNationalCurrency" },
  { text: "Платник", type: "text", value: "contractPartnerName" },
  { text: "ЄДРПОУ/ІПН платника", type: "text", value: "contractPartnerUSREOU" },
  { text: "Призначення платежу", type: "text", value: "reasonForPayment" },
  { text: "", component: "TransactionTypeLabel", value: "transactionType" },
  { text: "", component: "InfoMenu", style: "padding-right: 0", width: "35px" },
  { text: "", component: "CreatePaymentBtn", style: "padding-left: 5px", width: "35px" },
];
